import { Routes } from '@angular/router';
import { CmsPageComponent, cmsPageTemplateResolver } from '@domgen/dgx-fe-cms';
import { RegistrationGaCategory } from '@us-registration/util-models';

export const REGISTRATION_FEATURE_ORDER_CONFIRMATION_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      gaData: {
        category: RegistrationGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
    },
  },
];
